// Client de l'API centrale (même origine).
export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
    public data: Record<string, unknown> = {},
  ) {
    super(message);
  }
}

export async function api<T = unknown>(path: string, opts: { method?: string; body?: unknown; headers?: Record<string, string> } = {}): Promise<T> {
  const resp = await fetch(path, {
    method: opts.method ?? (opts.body !== undefined ? 'POST' : 'GET'),
    headers: { ...(opts.body !== undefined ? { 'Content-Type': 'application/json' } : {}), ...opts.headers },
    body: opts.body !== undefined ? JSON.stringify(opts.body) : undefined,
    credentials: 'same-origin',
    cache: 'no-store',
  });
  if (resp.status === 204) return undefined as T;
  const text = await resp.text();
  let data: Record<string, unknown> = {};
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    /* corps non JSON */
  }
  if (!resp.ok) throw new ApiError(resp.status, (data.error as string) ?? `Erreur ${resp.status}`, data);
  return data as T;
}

export interface PublicServer {
  id: string;
  name: string;
  url: string;
  sponsor: string;
  city: string;
  departement: string;
  pays: string;
  pays_nom: string;
  lat: number;
  lon: number;
  operator: string | null;
  capacity_mbps: number;
  load: number | null;
  distance_km: number;
}

export interface Whoami {
  ip: string;
  ip_version: number;
  asn?: number;
  operator?: string;
  commune?: string;
  departement?: string;
}

export interface PublicResult {
  share_id: string;
  created_at: string;
  server_id: string;
  server_name: string;
  server_city: string;
  operator: string | null;
  commune?: string;
  connection_type: string | null;
  download_mbps: number | null;
  upload_mbps: number | null;
  idle_ms: number | null;
  jitter_ms: number | null;
  loaded_down_ms: number | null;
  loaded_up_ms: number | null;
  grade: string | null;
  packet_loss: number | null;
  stable: boolean;
  method_version: string;
}
